import React, {PureComponent} from "react"
import {Query} from "@irati/utils/services/apollo"
import {ApolloQueryResult} from "@irati/utils/apollo"


import {gql} from "@irati/utils/gql"
import {PopularRewards} from "../../types"
import RewardCatalogueProduct from "./fragments/RewardCatalogueProduct"

interface Data {
  popularRewards: PopularRewards[]
}

export type PopularRewardsData = ApolloQueryResult<Data>

interface Props {}

const query = gql`
  query PopularRewards {
    popularRewards {
      rewards {
        uuid
        urlSlug
        status
        header
        description
        importantInfo
        deliveryInfo
        redemptionInstructions
        termsAndConditions
        bannerImage
        cardImage
        thumbnailImage
        products {
          results {
            ...RewardCatalogueProduct
          }
        }
      }
    }
  }
  ${RewardCatalogueProduct}
`

export default class PopularRewardsQueryComponent extends PureComponent<Props> {
  render() {
    return <Query query={query} {...this.props} />
  }
}
